import { z } from 'zod';
import { PERMISSIONS, terraContract } from '@terra/shared-authorization';
import {
  EnableOffensiveOperationsKillSwitchSchema,
  OffensiveOperationsKillSwitchStatusSchema,
  PdfReportBrandingResponseSchema,
  TenantSettingsResponseSchema,
  UpdatePdfReportBrandingSchema,
  UpdateTenantRemediationCodingToolsSettingsSchema,
} from './tenant-settings.schema';

import { TENANT_SETTINGS_PATH_NAME } from './tenant-settings.constants';

export const TenantSettingsContract = terraContract
  .prefix(`/${TENANT_SETTINGS_PATH_NAME}`)
  .router({
    getTenantSettings: terraContract
      .meta({
        authenticated: true,
      })
      .route({
        method: 'GET',
        path: '/',
        summary: 'Get tenant settings',
        inputStructure: 'detailed',
      })
      .output(TenantSettingsResponseSchema),
    updateRemediationCodingTools: terraContract
      .meta({
        permissions: [PERMISSIONS.MANAGE_APPLICATIONS.name],
      })
      .route({
        method: 'PUT',
        path: '/remediation-coding-tools',
        summary: 'Update remediation coding tools settings',
        inputStructure: 'detailed',
      })
      .input(
        z.object({ body: UpdateTenantRemediationCodingToolsSettingsSchema }),
      )
      .output(TenantSettingsResponseSchema),
    getPdfReportBranding: terraContract
      .meta({
        permissions: [PERMISSIONS.USER_ADMIN.name],
      })
      .route({
        method: 'GET',
        path: '/pdf-report-branding',
        summary: 'Get PDF report white-label branding settings',
        inputStructure: 'detailed',
      })
      .output(PdfReportBrandingResponseSchema),
    updatePdfReportBranding: terraContract
      .meta({
        permissions: [PERMISSIONS.USER_ADMIN.name],
      })
      .route({
        method: 'PUT',
        path: '/pdf-report-branding',
        summary: 'Update PDF report white-label branding settings',
        inputStructure: 'detailed',
      })
      .input(z.object({ body: UpdatePdfReportBrandingSchema }))
      .output(PdfReportBrandingResponseSchema),
    getOffensiveOperationsKillSwitch: terraContract
      .meta({
        authenticated: true,
      })
      .route({
        method: 'GET',
        path: '/offensive-operations-kill-switch',
        summary: 'Get tenant-wide offensive operations kill switch state',
        inputStructure: 'detailed',
      })
      .output(OffensiveOperationsKillSwitchStatusSchema),
    enableOffensiveOperationsKillSwitch: terraContract
      .meta({
        permissions: [PERMISSIONS.MANAGE_APPLICATIONS.name],
      })
      .route({
        method: 'POST',
        path: '/offensive-operations-kill-switch/enable',
        summary: 'Pause new offensive operations for this tenant',
        inputStructure: 'detailed',
      })
      .input(z.object({ body: EnableOffensiveOperationsKillSwitchSchema }))
      .output(OffensiveOperationsKillSwitchStatusSchema),
    disableOffensiveOperationsKillSwitch: terraContract
      .meta({
        permissions: [PERMISSIONS.MANAGE_APPLICATIONS.name],
      })
      .route({
        method: 'POST',
        path: '/offensive-operations-kill-switch/disable',
        summary: 'Resume new offensive operations for this tenant',
        inputStructure: 'detailed',
      })
      .input(z.object({ body: z.object({}) }))
      .output(OffensiveOperationsKillSwitchStatusSchema),
  });
